import { MilestoneIcon } from 'components/Dashboards/Portfolio/phasePerformance/components/milestoneIcon';
import classes from 'components/widgets/phasePerformanceChart/phasePerformanceChart.module.scss';

interface IMilestoneProps {
    name: string;
    projectName: string;
    isLast?: boolean;
}

export const Milestone = ({ name, projectName, isLast = false }: IMilestoneProps) => {
    return (
        <div className={`${classes.milestone} ${isLast ? classes.last : ''}`}>
            <div className={classes.title}>{name}</div>
            <MilestoneIcon projectName={projectName} name={name} />
        </div>
    );
};
